/**
 * @generated SignedSource<<32f862d7e2be2942bc9f483c2e8b1907>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BannersDismissMutation$variables = {
  noteId: string;
};
export type BannersDismissMutation$data = {
  readonly dismissAutomationTimeSaverBanner: {
    readonly note: {
      readonly viewerShowAutomationTimeSaverBanner: boolean;
    };
  } | null;
};
export type BannersDismissMutation = {
  response: BannersDismissMutation$data;
  variables: BannersDismissMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerShowAutomationTimeSaverBanner",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BannersDismissMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissAutomationTimeSaverBanner",
        "kind": "LinkedField",
        "name": "dismissAutomationTimeSaverBanner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BannersDismissMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissAutomationTimeSaverBanner",
        "kind": "LinkedField",
        "name": "dismissAutomationTimeSaverBanner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fdd78a786408162b0bfdd7d09a35a6e5",
    "id": null,
    "metadata": {},
    "name": "BannersDismissMutation",
    "operationKind": "mutation",
    "text": "mutation BannersDismissMutation(\n  $noteId: ID!\n) {\n  dismissAutomationTimeSaverBanner(noteId: $noteId) {\n    note {\n      viewerShowAutomationTimeSaverBanner\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "023a0b946e89b2ceb602eb6bc9634655";

export default node;
